// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pm-0";